module.exports = __webpack_public_path__ + "static/img/banner-03.3f6707a9.jpg";